(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'ClientOpportunityLinkGroup',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load($form)
	{
		$('.group-typeahead').on('ta.set-hidden', function click(e)
		{
			$('#link_opp_button').prop('disabled', false);
		});

		$('.group-typeahead').on('ta.reset', function click(e)
		{
			$('#link_opp_button').prop('disabled', true);

			$('#clientopportunitylinkgroup-group_type').val('');
			$('#clientopportunitylinkgroup-group_source').val('');
		});

	};
}(jQuery, window.Adzuki || {}));
